import * as request from "../lib/lib";
import Swal from 'sweetalert2'

const baseUrl = process.env.REACT_APP_BACKEND_URL;



export const create = async (formData) => {

    const contentType = 'multipart/form-data';
    let result = null;
   

    try {
        result = await request.postFile(`${baseUrl}GetInfo/Schedule`, formData, contentType);
        Swal.fire({ title: "Успешно обновяване на графика!", text: "", icon: "success" });
    } catch (error) {
        Swal.fire({ title: "Грешка при обновяване!", text: error.message, icon: "error" });
    }

    const data = Object.values(result);

    return data;
};


export const getApplicationPDF = async (body) => {
    const result = await request.getPdf(`${baseUrl}Application/LastPDF`, body);

    return result;
}

export const generateHistoryPdf = async (formData) => {


    const result = await request.getPdf(`${baseUrl}Application/HistoryPDF`, formData);

    return result;
};

export const getArchiveRankingChildrenPDF = async (id, schoolId) => {
    const result = await request.getArchivePdfRef(`${baseUrl}Archive/RankingChildren/${id}${schoolId ? `?schoolId=${schoolId}` : ''}`);

    return result;
}

export const getArchiveConfirmedChildrenPDF = async (id, schoolId) => {
    const result = await request.getArchivePdfRef(`${baseUrl}Archive/ConfirmedChildren/${id}${schoolId ? `?schoolId=${schoolId}` : ''}`);

    return result;
}

export const getArchiveCancelledChildrenPDF = async (id, schoolId) => {
    const result = await request.getArchivePdfRef(`${baseUrl}Archive/CancelledChildren/${id}${schoolId ? `?schoolId=${schoolId}` : ''}`);

    return result;
}

export const getArchiveExiredChildrenPDF = async (id, schoolId) => {
    const result = await request.getArchivePdfRef(`${baseUrl}Archive/ExiredChildren/${id}${schoolId ? `?schoolId=${schoolId}` : ''}`);

    return result;
}

